import { jsonFetch } from "@/lib/helpers";
import { Task } from "@/models";
import { GET_TASKS } from "./api-url.constants";
import { TasksApiDTO } from "./dtos";
import { mapTaskDTOToTask } from "./mappers";

export const getTasks = async (urlParams: string): Promise<Task[]> => {
  const url = `${GET_TASKS}?${urlParams}`;

  const tasksDTO = await jsonFetch<TasksApiDTO>(url);
  return tasksDTO.data.map(mapTaskDTOToTask);
};
